import { axiosSingleton } from "@/plugins/axios";
import { construirAlertaRespuesta } from "./snackbar";
import router from "@/router/index";

const controller = "/Permisos";

const state = {
  administrador: true,
};

const mutations = {
  setAdministrador(state, administrador) {
    state.administrador = administrador;
  },
};

const actions = {
  async consultaAdministrador({ commit }, { mostrarAlerta }) {
    const resp = await axiosSingleton
      .getInstance()
      .get(`${controller}/Administrador`)
      .then(async (res) => {
        commit("setAdministrador", res.data.data);
        return construirAlertaRespuesta(res);
      })
      .catch((err) => construirAlertaRespuesta(err, true));

    mostrarAlerta(resp);
  },
  to({ state }, { path, admin }) {
    //if (!admin || state.administrador) {
    router.push(path);
    //} else {
    //router.push("/");
    //}
  },
};

const getters = {
  administrador: (state) => state.administrador,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
